import { render, staticRenderFns } from "./PartnerPayment.vue?vue&type=template&id=c5b47518&"
import script from "./PartnerPayment.vue?vue&type=script&lang=ts&"
export * from "./PartnerPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports